module.exports = __webpack_public_path__ + "static/img/footer_logo.c1e163f0.png";